import React, { useCallback, useEffect, useRef } from 'react';
import { useToggle } from 'react-use';
import { AppDiscoveryDesc } from '../ui/discovery/AppDiscoveryDesc';
import { AppDiscveryMobile } from '../ui/discovery/AppDiscoveryMobile';
import { getIsMobile } from '../utils/getIsMobile';
import { getWindow } from '../utils/getWindow';
import { useIsSomeDialogOpen, useOpenDialog } from './ModalRoute';
import { DIALOGS } from './constants';

const APP_DISCOVERY_DELAY = 20000;
const APP_DISCOVERY_LS_KEY = 'app-discovery-is-shown';

export const AppDiscovery = () => {
    const openDialog = useOpenDialog();
    const [isVisible, toggleIsVisible] = useToggle(false);
    const isSomeDialogOpen = useIsSomeDialogOpen();
    const isMobile = getIsMobile();

    const isSomeDialogOpenRef = useRef(isSomeDialogOpen);
    const toggleIsVisibleRef = useRef(toggleIsVisible);
    const timerStartedRef = useRef(false);

    useEffect(() => {
        toggleIsVisibleRef.current = toggleIsVisible;
        isSomeDialogOpenRef.current = isSomeDialogOpen;
    }, [toggleIsVisible, isSomeDialogOpen]);

    useEffect(() => {
        if (timerStartedRef.current) {
            return;
        }

        timerStartedRef.current = true;
        setTimeout(() => {
            const isShown = getWindow()?.localStorage.getItem(APP_DISCOVERY_LS_KEY);

            if (!isSomeDialogOpenRef.current && !isShown) {
                toggleIsVisibleRef.current();
                getWindow()?.localStorage.setItem(APP_DISCOVERY_LS_KEY, 'true');
            }
        }, APP_DISCOVERY_DELAY);
    }, []);

    const onCloseAndShowQrDialog = useCallback(() => {
        toggleIsVisible();
        openDialog(DIALOGS.APPS_QR);
    }, [toggleIsVisible, openDialog]);

    if (!isVisible) {
        return null;
    }

    return isMobile ? (
        <AppDiscveryMobile onClose={toggleIsVisible} />
    ) : (
        <AppDiscoveryDesc
            onClose={toggleIsVisible}
            onCloseAndShowQrDialog={onCloseAndShowQrDialog}
        />
    );
};
